var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/edit-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.8596 16.1227C3.32451 16.1227 2.82451 15.9385 2.46486 15.5964C2.00872 15.1666 1.78942 14.5174 1.86837 13.8157L2.19293 10.9736C2.25433 10.4385 2.5789 9.72798 2.95609 9.34201L10.1578 1.7192C11.9561 -0.184305 13.8333 -0.236936 15.7368 1.56131C17.6403 3.35956 17.6929 5.23675 15.8947 7.14026L8.69293 14.7631C8.32451 15.1578 7.6403 15.5262 7.10521 15.6139L4.28065 16.0964C4.13153 16.1052 3.99995 16.1227 3.8596 16.1227ZM12.9736 1.55254C12.2982 1.55254 11.7105 1.97359 11.114 2.60517L3.91223 10.2367C3.73679 10.421 3.53504 10.8596 3.49995 11.1139L3.17539 13.956C3.1403 14.2455 3.21047 14.4824 3.36837 14.6315C3.52626 14.7806 3.76311 14.8332 4.05258 14.7894L6.87714 14.3069C7.13153 14.2631 7.55258 14.035 7.72802 13.8508L14.9298 6.22798C16.0175 5.07008 16.4122 3.99991 14.8245 2.50868C14.1228 1.83324 13.5175 1.55254 12.9736 1.55254Z",
    fill: "#00365A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2105 8.60517C14.1929 8.60517 14.1666 8.60517 14.1491 8.60517C11.4122 8.33324 9.21047 6.25429 8.78942 3.53499C8.73679 3.17534 8.9824 2.84201 9.34205 2.78061C9.7017 2.72798 10.035 2.97359 10.0964 3.33324C10.4298 5.45605 12.1491 7.08763 14.2894 7.29815C14.6491 7.33324 14.9122 7.6578 14.8771 8.01745C14.8333 8.35078 14.5438 8.60517 14.2105 8.60517Z",
    fill: "#00365A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.421 18.956H1.63153C1.27188 18.956 0.973633 18.6578 0.973633 18.2982C0.973633 17.9385 1.27188 17.6403 1.63153 17.6403H17.421C17.7806 17.6403 18.0789 17.9385 18.0789 18.2982C18.0789 18.6578 17.7806 18.956 17.421 18.956Z",
    fill: "#00365A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit2);
export default __webpack_public_path__ + "static/media/edit-2.0ab968c5e94305a490578589e575fd2e.svg";
export { ForwardRef as ReactComponent };